export default function RetainedInformation() {
    return (
        <section>
            <h2 id="retained-information" data-testid="retained-information">
                VI. RETENÇÃO DAS INFORMAÇÕES COLETADAS
            </h2>
            <p>
                As informações coletadas pela AMBEV por meio do App serão
                automaticamente excluídas de seus servidores quando deixarem de
                ser úteis para os fins para os quais foram coletadas, ou quando
                o usuário solicitar a eliminação de seus dados pessoais ou
                revogar o consentimento concedido para o tratamento dos dados,
                hipótese em que o acesso do Usuário ao App será interrompido.
            </p>
            <p>
                Sem prejuízo, as informações poderão ser conservadas para
                cumprimento de obrigação legal ou regulatória, transferência a
                terceiro - desde que respeitados os requisitos de tratamento de
                dados - e uso exclusivo da AMBEV, vedado seu acesso por
                terceiro, desde que anonimizadas.
            </p>
        </section>
    );
}
